export const createSlide = `mutation MyMutation(
  $AnimalID: String!,
  $Block: String,
  $ControlGroup: String,
  $Dzi: String,
  $ImageFileName: String,
  $Magnification: String,
  $Organ: String,
  $Scanner: String,
  $Set: String,
  $SlideName: String!,
  $SlideStatus: String,
  $StudyID: String!
) {
  createSlide(slide: {
    AnimalID: $AnimalID,
    Block: $Block,
    ControlGroup: $ControlGroup,
    Dzi: $Dzi,
    ImageFileName: $ImageFileName,
    Magnification: $Magnification,
    Organ: $Organ,
    Scanner: $Scanner,
    Set: $Set,
    SlideName: $SlideName,
    SlideStatus: $SlideStatus,
    StudyID: $StudyID
  }) {
    AnimalID
    Block
    ControlGroup
    Dzi
    ID
    ImageFileName
    Magnification
    Organ
    Scanner
    Set
    SlideName
    SlideStatus
    StudyID
  }
}`;

export const updateSlide = `mutation MyMutation(
  $AnimalID: String!,
  $Block: String,
  $ControlGroup: String,
  $Dzi: String,
  $ImageFileName: String,
  $Magnification: String,
  $Organ: String,
  $Scanner: String,
  $Set: String,
  $SlideName: String!,
  $SlideStatus: String,
  $StudyID: String!,
  $ID: String!
) {
  updateSlide(slide: {
    AnimalID: $AnimalID,
    Block: $Block,
    ControlGroup: $ControlGroup,
    Dzi: $Dzi,
    ImageFileName: $ImageFileName,
    Magnification: $Magnification,
    Organ: $Organ,
    Scanner: $Scanner,
    Set: $Set,
    SlideName: $SlideName,
    SlideStatus: $SlideStatus,
    StudyID: $StudyID,
    ID: $ID
  }) {
    Block
    AnimalID
    ControlGroup
    Dzi
    ID
    ImageFileName
    Magnification
    Organ
    Scanner
    Set
    SlideName
    SlideStatus
    StudyID
  }
}`;

/**
 * 其实这个名为getSlide，但相当于返回的是Slide下所有信息，包括Study等
 */
export const getSlide = `query MyQuery($id: String!) {
  getSlide(id: $id) {
    AnimalID
    Block
    ControlGroup
    Dzi
    ID
    ImageFileName
    Magnification
    Organ
    Scanner
    Set
    SlideName
    StudyID
    SlideStatus
    PPM
    Metadata
    Annotation {
      Content
      ID
      SlideID
    }
    Animal {
      Administration
      AnimalName
      Dose
      Group
      ID
      SacrificePeriod
      Sex
      Stain
      StudyID
    }
    InterimSlideNote {
      Directionality
      Finding
      FindingInhand
      ID
      Laterality
      ServerityInhand
      Severity
      SlideID
      Comment
    }
    SlideNote {
      Directionality
      Finding
      FindingInhand
      ID
      Laterality
      ServerityInhand
      Severity
      SlideID
      Comment
    }
    SlideObservation {
      Directionality
      Finding
      FindingInhand
      ID
      Laterality
      ServerityInhand
      Severity
      SlideID
      Comment
    }
    Study {
      Administration
      ID
      Species
      Sponsor
      Strain
      StudyName
      TestFacility
      Type
      UserListID
    }
  }
}`